import { Box, Stack } from '@mui/material';
import { PageHeader } from '@/components/PageHeader';
import { AiSection } from './AiSection';
import { DataRequestsSection } from './DataRequestsSection';
import { IntegrationsSection } from './IntegrationsSection';

export function SettingsScreen() {
  return (
    <Box>
      <PageHeader id="settings" />
      <Stack spacing={3}>
        <AiSection />
        <DataRequestsSection />
        <IntegrationsSection />
      </Stack>
    </Box>
  );
}
